import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "../../../../common/api";
import {
  removeLoginInfo,
  removeCurrentInfo,
} from "../../../../features/mobile/commonSlice";
import { onResetQuestionComplete } from "../../../../features/mobile/otherSlice";
import HeadCont from "../../components/common/HeadCont";
import Dialog from "../../components/common/Dialog";
import { storage } from "../../../../utils/storage";

const Account = () => {
    const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginInfo } = useSelector((state) => state.commonApp);
  const [openDialog, setOpenDialog] = useState(false);

  // Scroll to top on page load
  useEffect(() => {
    // Try multiple approaches to ensure scroll works
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Also try after a slight delay to ensure it works after render
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 100);
  }, []);

  const datas = [
    {
      id: 1,
      subMenu: [
        {
          id: 1,
          title: "Change Password",
          titleKey: 'change_password',
          onAction: () => navigate("/account/editpass"),
        },
        {
          id: 2,
          title: "Manage Profile",
          onAction: () => navigate("/account/profile"),
        },
        { id: 3, title: "Log Out", onAction: () => setOpenDialog(true) },
        { id: 4, title: "Delete Account", onAction: () => navigate("/resign") },
      ],
    },
  ];
  console.log(loginInfo);
  const onLogout = async () => {
    // 로그아웃 - 서버에 토큰 삭제 요청(자동로그인 방지)은 best-effort.
    // 서버가 실패(네트워크/502/유저 불일치)해도 클라이언트 로그아웃은 항상 진행한다.
    try {
      if (loginInfo?.userId) {
        await api.get(`/user/logout/${loginInfo.userId}`);
      }
    } catch (err) {
      console.log("logout api failed (continuing):", err);
    }

    // 로컬 자동로그인 자격증명 정리 - 하나가 실패해도 나머지/네비게이션을 막지 않는다
    await Promise.allSettled([
      storage.removeItem('autoLogin'),
      storage.removeItem('autoLoginEmail'),
      storage.removeItem('autoLoginPass'),
      storage.removeItem('accessToken'),
    ]);

    // 항상 상태 초기화 + 로그인 화면으로 이동
    dispatch(removeLoginInfo());
    dispatch(removeCurrentInfo());
    dispatch(onResetQuestionComplete());
    setOpenDialog(false);
    navigate("/sign", { replace: true });
  };

  return (
    <>
      <HeadCont rightIcon={"no icon"} title={"Account"} bgColor={"bg-back_ground"} />
      <section className="mb-6 safe-area-mt-header-minimal bg-back_ground min-h-screen">
        {datas.map((data) => (
          <div key={data.id} className="p-4 ">
            <ul>
              {data.subMenu.map((menu) => {
                if (
                  menu.titleKey === 'change_password' &&
                  loginInfo.existPass === false
                ) {
                  return;
                } else {
                  return (
                    <li
                      onClick={(e) => {
                        menu.onAction();
                      }}
                      key={menu.id}
                      className={
                        "flex justify-between rounded-md p-3 cursor-pointer"
                      }
                      style={{
                        WebkitTapHighlightColor: 'transparent',
                        userSelect: 'none',
                        WebkitUserSelect: 'none'
                      }}
                    >
                      <h2 className="text-body3_700 text-gray_180" style={{ pointerEvents: 'none', userSelect: 'none' }}>
                        {menu.title}
                      </h2>
                      <img
                        src="/images/mobile/icon/right.svg"
                        alt={"More icon"}
                        style={{ pointerEvents: 'none', userSelect: 'none' }}
                      />
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        ))}
      </section>
      {openDialog && (
        <Dialog
          innerClass={"p-4"}
          title={"Log Out"}
          desc={"Are you sure you want to log out?"}
          leftBtnTitle={"Stay Logged In"}
          rightBtnTitle={"Log Out"}
          onLeftBtnAction={() => setOpenDialog(false)}
          onRightBtnAction={onLogout}
          onCoverAction={() => setOpenDialog(false)}
        />
      )}
    </>
  );
};

export default Account;
